<template>
  <article class="article-item img-16by9 item-type-article">
    <div class="article-wrap">
      <div class="article-thumbnail">
        <a :href="matchUrl(article)" @click="onMatchClick($event, article)">
          <div class="img-box">
            <img
              v-if="lazyImgType"
              class="lazy"
              :src="match_image(null, size)"
              :data-src="match_image(article, size)"
              :alt="article.asset_title"
            />
            <img
              v-else
              :src="match_image(article, size)"
              :alt="article.asset_title"
              importance="high"
            />
          </div>
          <span class="item-type-icon"></span>
        </a>
      </div>
      <div class="article-content">
        <a :href="matchUrl(article)" @click="onMatchClick($event, article)">
          <p class="article-title">{{ article.asset_title }}</p>
        </a>

        <div class="article-meta">
          <time
            class="meta meta-date"
            :data-date="getTimeSpan(article.published_date, true)"
            >{{ getTimeSpan(article.published_date) }}</time
          >
        </div>
        <div class="article-description">
          <p>{{ article.short_desc }}</p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
import {
  daysBetween,
  addPagePropertiesToObject,
  sendTrackingData,
  urlCorrections,
} from "../../assets/js/common";
import {
  CFG_WIDGET_URL_BASE,
  CFG_TRACKING,
  CFG_MODULES,
} from "../../assets/js/config";
export default {
  props: [
    "article",
    "size",
    "isFirstTile",
    "listing_module",
    "headline_keys",
    "showDreamTeamImg",
    "showVideoImg",
    "lazyImgType",
  ],
  data() {
    return {
      defaultImg: {
        square:
          "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-square.png",
        rect: "https://www.fantasygully.com/static-assets/images/cssimages/default-lazy-rect.png",
      },
    };
  },
  computed: {
    translations() {
      return this.$store.state.translations;
    },
  },
  methods: {
    match_image(match, width) {
      let dimensions = this.isFirstTile ? "592-444" : "388-218";
      let mImgUrl = `${this.defaultImg[this.lazyImgType]}?w=${width}`;
      if (match) {
        mImgUrl = `${CFG_WIDGET_URL_BASE}/static-assets/waf-images/${match.image_path}${dimensions}/${match.image_file_name}`;
      }
      return mImgUrl;
    },
    getTimeSpan(time, sendDateString) {
        if (time) {
            if (time.indexOf("+") == -1) {
                time = time + "+00:00"; // make sure that time is UTC format
            }
            if (sendDateString) {
                return time;
            } else {
                const epochs = [
                    ["year", 31536000],
                    ["month", 2592000],
                    ["day", 86400],
                    ["hour", 3600],
                    ["minute", 60],
                    ["second", 1],
                ];
      
                const getDuration = (timeAgoInSeconds) => {
                    if (timeAgoInSeconds < 0) {
                        timeAgoInSeconds = Math.abs(timeAgoInSeconds);
                    }
                    for (let [name, seconds] of epochs) {
                        const interval = Math.floor(timeAgoInSeconds / seconds);
                        if (interval >= 1) {
                            return {
                                interval: interval,
                                epoch: name,
                            };
                        }
                    }
                };
      
                let timeSpan = daysBetween(new Date(), new Date(time));
                const timeAgoInSeconds = timeSpan.ms_Diff / 1000;
                const { interval, epoch } = getDuration(timeAgoInSeconds);
                const suffix = interval === 1 ? "" : "s";
      
                if (timeSpan.is_expired) {
                    /* ago */
                    return `${interval} ${epoch}${suffix} ago`;
                } else {
                    /* to go */
                    return `${interval} ${epoch}${suffix} to go`;
                }
            }
        } else {
            return "";
        }
    },
    matchUrl(obj) {
      let url = null;
      if (this.$route && this.$route.path) {
        let teamHtohUrlKey = CFG_MODULES.TEAM_HTOH.route;
        let playerHtohUrlKey = CFG_MODULES.PLAYER_HTOH.route;
        if (this.$route.path.includes(teamHtohUrlKey.replace(/\//g, ""))) {
          url = urlCorrections(`${teamHtohUrlKey}${obj.title_alias}`);
        } else if (
          this.$route.path.includes(playerHtohUrlKey.replace(/\//g, ""))
        ) {
          url = urlCorrections(`${playerHtohUrlKey}${obj.title_alias}`);
        }
      }

      return url;
    },
    onMatchClick(e, obj) {
      let category = "click_to_head_to_head";
      let teamHtohUrlKey = CFG_MODULES.TEAM_HTOH.route;
      let playerHtohUrlKey = CFG_MODULES.PLAYER_HTOH.route;
      if (this.$route.path.includes(teamHtohUrlKey.replace(/\//g, ""))) {
        category = "click_to_team_head_to_head";
      } else if (
        this.$route.path.includes(playerHtohUrlKey.replace(/\//g, ""))
      ) {
        category = "click_to_player_head_to_head";
      }

      let toTrack = CFG_TRACKING["2"];
      toTrack.category = category;
      toTrack.value = this.matchUrl(obj);
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
  },
};
</script>